
/**
 * Menu Solicitante
 * General
 */
export const panelSolicitanteMenus = [
	{
		icon: "dashboard",
		text: "Mi panel",
		to: {
			path: "/panel-facto/estadisticas"
		}
	},
	{
		icon: "receipt",
		text: "Anticipar facturas",
		to: {
			path: "/panel-facto/anticipo-facturas"
		}
	},
	{
		icon: "receipt_long",
		text: "Ceder facturas",
		to: {
			path: "/panel-facto/ceder-facturas"
		}
	},
	{
		icon: "topic",
		text: "Mis operaciones",
		to: {
			path: "/panel-facto/mis-operaciones"
		}
	},
	{
		icon: "person",
		text: "Mis datos",
		to: {
			path: "/panel-facto/datos-personales"
		}
	},
	{
		icon: "lock",
		text: "Mis claves y certificados",
		to: {
			path: "/panel-facto/mis-claves"
		}
	},
	{
		icon: "business",
		text: "Mis empresas",
		to: {
			path: "/panel-facto/empresas"
		}
	},
	{
		icon: "folder_special",
		text: "Mis documentos",
		to: {
			path: "/panel-facto/documentos"
		}
	},
	{
		icon: "analytics",
		text: "Mis finanzas",
		to: {
			path: "/panel-facto/finanzas"
		}
	},
	{
		icon: "paid",
		text: "Mora cartera clientes",
		to: {
			path: "/panel-facto/cobranza"
		}
	},
];
